module.exports = __webpack_public_path__ + "img/icon-area.01db3216.svg";